// extracted by mini-css-extract-plugin
module.exports = {"details":"DepartmentDetails_details__3DjSW"};